"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EquipmentSki = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EquipmentSki = function EquipmentSki(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.089 8.12c.631 0 1.467-.244 1.467-.733V6.164s-.734-.488-2.445-.488c-1.711 0-2.444.488-2.444.488v1.223c0 .489.835.733 1.466.733.734 0 .49-.611.978-.611.489 0 .245.611.978.611zm-.163 2.658a.42.42 0 10-.592.593.42.42 0 00.592-.593zM8.741 9.593a.419.419 0 10-.593.593.419.419 0 00.593-.593zM5.185 6.037a.419.419 0 10-.593.593.419.419 0 00.593-.593zM4 4.852a.419.419 0 10-.593.592A.419.419 0 004 4.852zm8.593 9.186a2.512 2.512 0 01-1.785.74 2.52 2.52 0 01-2.033-1.025l-.591-.8a30.314 30.314 0 00-6.36-6.36l-.8-.59a2.526 2.526 0 113.534-3.534l.591.8c.486.657.999 1.291 1.534 1.905a5.856 5.856 0 011.411-.326L11.942 1 13.2 2.257 10.547 4.91c.442.08.786.183 1.03.28l.467-.467C14.262 2.504 16 2.023 16 2.023s-.48 1.738-2.7 3.956l-.856.857v.55c0 .896-.837 1.43-1.8 1.579.285.226.572.448.864.664l.8.591a2.526 2.526 0 01.285 3.818zm-9.792-.073l1.257 1.257L6.74 12.54a29.904 29.904 0 00-1.161-1.354c-1.561 1.563-2.78 2.78-2.78 2.78zM3.956 11.5C1.738 13.72 0 14.2 0 14.2s.48-1.738 2.7-3.957l.972-.974c.438.4.862.815 1.274 1.241l-.99.99z",
    fill: "currentColor"
  }));
};

exports.EquipmentSki = EquipmentSki;
var _default = EquipmentSki;
exports.default = _default;